import React, { useMemo } from "react";
import { BlockRecord } from "models/view-models/block-record";
import { NotebookPageContentBlock } from "constants/notebooks/notebook-page-content-blocks";
import { DefaultReadonlyPageBlock } from "organisms/page-blocks/readonly-page-block/default-readonly-page-block";
import { ReadonlyCodeReferencePageBlock } from "organisms/page-blocks/readonly-page-block/readonly-code-reference-page-block";
import { ReadonlyChecklistPageBlock } from "organisms/page-blocks/readonly-page-block/readonly-checklist-page-block";
import { ReadonlyContextProvider } from "utilities/contexts/readonly/readonly-context-provider";

export interface ReadonlyPageBlockProps {
    block: BlockRecord;
    onRequestEditMode?: () => void;
    printable?: boolean;
}

const BLOCK_TYPE_TO_READONLY_BLOCK_COMPONENT_MAP: Record<
    NotebookPageContentBlock,
    React.FC<ReadonlyPageBlockProps>
> = {
    [NotebookPageContentBlock.Text]: DefaultReadonlyPageBlock,
    [NotebookPageContentBlock.CodeReference]: ReadonlyCodeReferencePageBlock,
    [NotebookPageContentBlock.Checklist]: ReadonlyChecklistPageBlock,
    [NotebookPageContentBlock.Image]: DefaultReadonlyPageBlock,
};

export const ReadonlyPageBlock = (
    props: ReadonlyPageBlockProps
): JSX.Element => {
    const ReadonlyComponent = useMemo(() => {
        return BLOCK_TYPE_TO_READONLY_BLOCK_COMPONENT_MAP[props.block.type];
    }, [props.block.type]);

    return (
        <ReadonlyContextProvider isReadonly={true}>
            <ReadonlyComponent {...props} />
        </ReadonlyContextProvider>
    );
};
